import { createApp } from "vue";
import Alert from "@/plugins/alert";
import i18n from "./helpers/i18n";
import App from "./App.vue";
import router from "./router";

// styles
import "./styles.css";

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(Alert);

app.mount("#app");
